'use client';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { PopoverContentInternal } from '../popover/popover-content-internal.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, o) {
    return r in e ? Object.defineProperty(e, r, {
        value: o,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = o, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var o = null != arguments[r] ? arguments[r] : {}, t = Object.keys(o);
        "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
            return Object.getOwnPropertyDescriptor(o, e).enumerable;
        }))), t.forEach(function(r) {
            _define_property(e, r, o[r]);
        });
    }
    return e;
}
const MenuPopover = renderWithRef('MenuPopover', {}, (n, i)=>{
    let { children: a, className: s, placement: m = 'bottom start', hideArrow: l = true } = n, { overlayState: f } = useSwanPopover(), u = assignRefs(i, useRef(null)), b = new Set([
        'swan-menu-popover',
        'swan-listbox-popover'
    ]);
    return s && b.add(s), f.isOpen ? jsx(RenderComp, {
        root: PopoverContentInternal,
        forwardedRef: u,
        classNames: b,
        props: _object_spread({
            placement: m,
            hideArrow: l
        }, n),
        children: a
    }) : jsx("div", {
        "aria-hidden": "true",
        className: "swan-display-none",
        children: a
    });
});

export { MenuPopover };
